import {
  getMoreViolations,
  getViolations,
  historyType,
  onClickPay,
  payType,
  ServiceSubCategory,
  serviceType,
  singleViolation,
} from '@/commonTypes';
import PageCard from '@/components/general/PageCard';
import React, { useState } from 'react';
import styles from './styles.module.css';
import MainIcons from '@/icons/main';
import { avatarBg } from '@/functions/formats';
import { useLayoutContext } from '@/context/LayoutContext';
import ViolationBadge from './ViolationBadge';
import Button from '@/components/common/Button';
import ViolationImageModal from '@/components/Modals/ModalsContainer/ViolationImageModal';
import { subCategoryIdList, TRIGGERS } from '@/api/global';
import AppImage from '@/components/common/AppImage';
import Api from '@/api';

interface HistoryResponse {
  response: historyType[];
  total: number;
}

export default function SingleViolationResult({
  data,
  onClick,
  disabledButton = false,
  // violationCount,
  getMoreViolations,
  imagesService,
  callBackHistory,
  getViolations,
  loadingViolations = false,
}: {
  data?: ServiceSubCategory;
  onClick?: onClickPay;
  disabledButton?: boolean;
  // violationCount?: string | number;
  getMoreViolations?: getMoreViolations;
  imagesService?: ServiceSubCategory;
  callBackHistory?: any;
  getViolations?: getViolations;
  loadingViolations?: boolean;
}) {
  const { rowPaletColors, priceSymbol, setTrigger } = useLayoutContext();
  const [violationImageInfo, setViolationImageInfo] = useState(null);
  console.log('datais==', data);
  console.log('violationImageInfo====', violationImageInfo);
  const showPreGetPhoto = (item: { response?: singleViolation }) => {
    Api.serviceHistory({
      params: {
        service_identifier: subCategoryIdList.vehicle_fines_image,
        violation_id: item?.response?.violation_id,
        start: 0,
        limit: 1,
      },
    })
      .then((res: any) => {
        // const value = Object.values(res?.data?.response ?? {})[0] as HistoryResponse | undefined;
        // console.log('imageres==', value);
        let value = res?.data?.response?.ViolationImage;
        console.log('value======', res);
        setViolationImageInfo(value?.response?.[0]?.response);
        // let newresponse;
        // if (start == 0) {
        //   newresponse = value?.response;
        // } else {
        //   newresponse = history?.concat(value?.response);
        // }
        // setTotalHistoryCount(value?.total ?? 0);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  return (
    <>
      <div className={`${styles.list}`}>
        {data?.items?.map((item: { response?: singleViolation }, index: number) => {
          const palette = rowPaletColors[index % rowPaletColors.length];

          const accent = palette.accent;
          const bg = palette.bg;
          const valColor = palette.valColor;
          return (
            <PageCard
              key={index}
              title={
                <div className={`${styles.titleContainer}`}>
                  {item?.response?.violation_type?.violation_type_name != '0' &&
                    item?.response?.violation_type?.violation_type_name}
                  <ViolationBadge />
                </div>
              }
              text={
                <>
                  <div className={styles.fineMeta}>
                    <span>
                      <MainIcons.clockIcon width="14px" height="14px" /> {'تاریخ جریمه:'}{' '}
                      {item?.response?.violation_occured_date}
                    </span>
                    <span>
                      <MainIcons.coinIcon width="14px" height="14px" /> {'مبلغ:'}{' '}
                      <b className={styles.fineAmount}>
                        {Number(item?.response?.final_price ?? 0).toLocaleString()} {priceSymbol}
                      </b>
                    </span>
                  </div>
                  {item?.response?.has_image && (
                    <div
                      className={`${styles.imageViolation}`}
                      onClick={() => {
                        if (!item?.response?.is_photo_taken) {
                          onClick &&
                            onClick(
                              'inq',
                              { ...imagesService, violation_id: item?.response?.violation_id },
                              (x: any) => {
                                setViolationImageInfo(x?.ViolationImage);
                              },
                            );
                        } else {
                          showPreGetPhoto(item);
                        }
                      }}
                    >
                      <AppImage
                        src={'/imgs/shop/imageIcon.svg'}
                        alt={'image'}
                        objectPosition="center center"
                        width={18}
                        height={18}
                      />
                      <span> تصویر خلافی</span>
                    </div>
                  )}
                </>
              }
              backgroundIcon={bg}
              icon={<MainIcons.flashIcon fill={valColor} width="25px" height="25px" />}
              iconClass={`${styles.icon}`}
              className={`${styles.pageCard}`}
              titleClass={`${styles.titleClass}`}
              headClass={`${styles.headClass}`}
              aside={
                item?.response?.final_price != 0 && (
                  <Button
                    className={`btn btn-primary squareButton`}
                    onClick={() => {
                      onClick &&
                        onClick(
                          'pay',
                          { ...item, price: item?.response?.final_price, history_id: data?.id },
                          callBackHistory,
                        );
                    }}
                    disabled={disabledButton}
                  >
                    <MainIcons.LockIcon fill="#fff" width="16px" height="16px" />
                    پرداخت خلافی
                  </Button>
                )
              }
            />
          );
        })}
        {data?.items && data?.items?.length < Number(data?.items_count) && (
          <Button
            loading={loadingViolations}
            wrapperStyle="w-full flex"
            className={`btn btn-white squareButton mx-auto`}
            onClick={() => {
              if (getMoreViolations && data?.items?.length !== undefined) {
                getMoreViolations(data?.items?.length, data?.id);
              }
            }}
          >
            بیشتر
          </Button>
        )}
      </div>
      {violationImageInfo && (
        <ViolationImageModal
          isOpen={violationImageInfo != null}
          onClose={() => {
            setViolationImageInfo(null);
            setTrigger(TRIGGERS.EMPTY);
          }}
          violationImageInfo={violationImageInfo}
        />
      )}
    </>
  );
}
